/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type TopBar_user = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopBar_user",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "AccountNav_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Rewards_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CartNav_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Notifications_user",
      "args": null
    }
  ],
  "type": "User"
};

module.exports = fragment;
